var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"95%","margin":"auto"}},[_c('div',{staticClass:"agreement",domProps:{"innerHTML":_vm._s(_vm.introduce)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }